export default function getWireId() {
  const $wireId = $('form input[name="wire[id]"]');

  return !$wireId.length ? null : $wireId.val();
}
